/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairSearchParameters } from '../../models/finnair-search-parameters';
import { MultiOfferList } from '../../models/multi-offer-list';

export interface FindMultiOfferList$Params {
      body: FinnairSearchParameters
}

export function findMultiOfferList(http: HttpClient, rootUrl: string, params: FindMultiOfferList$Params, context?: HttpContext): Observable<DapiHttpResponse<MultiOfferList>> {
  const rb = new DapiRequestBuilder(rootUrl, findMultiOfferList.PATH, 'post');

  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<MultiOfferList>;
    }),
    catchErrorAsJson()
  );
}

findMultiOfferList.PATH = '/api/multi/offerList';
